import {   postAccountClosure, postUpdateBank } from "../../../helpers/fakebackend_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const reKyc_AccountClosureThunk = createAsyncThunk(
  "reKyc_AccountClosureThunk",
  async ({ body, token }) => {
    try {
      const response = postAccountClosure(body, token);
      return response;
    } catch (error) {
      return error;
    }
  }
);
